<template v-if="this.aluno">
    <div class="md-layout dados-aluno-main">
        <div class="md-layout-item md-size-33 md-small-size-50 md-xsmall-size-100"
             v-for="t in layout" :key="t.description" v-bind:class="{'md-small-hide' : !t.description}">
            <div class="dados-item">
                <md-icon>{{t.icon}}</md-icon>
                <span class="s-h4">{{t.description}}</span>
                <span v-if="aluno[t.data]" class="s-h3 regular data" v-bind:title="aluno[t.data]">{{aluno[t.data]}}</span>
                <span v-else-if="t.description" class="s-h3 regular data">Não Cadastrado</span>
            </div>

        </div>
    </div>

</template>

<script>
    export default {

        name: 'DadosAluno',

        props: {
        },

        data() {
            return {
                aluno: null,

                layout: [
                    { icon: "mail", description: "Email", data: "email" },
                    { icon: "phone", description: "Telefones", data: "_formatTelefones" },
                    {},
                    { icon: "account_balance", description: "Unidade", data: "_formatUnidade" },
                    { icon: "school", description: "Turma", data: "_formatTurma" },
                    { icon: "menu_book", description: "Curso", data: "_formatCurso" },

                ]


            }
        },

        methods: {
            gerarCamposDescritivos() { 
                if (this.aluno) {
                    let telefones = [this.aluno['telefone'], this.aluno['telefone2'], this.aluno['telefone3'], this.aluno['telefone4']];
                    telefones = telefones.filter(t => t.replace(/ /g, '').length > 3);//remove telefones vazios
                    telefones = telefones.map(t => t.replace(/ /g, ''));
                    this.aluno._formatTelefones = telefones.join(" | ");
                    this.aluno._formatTurma = `${this.aluno["codigoTurma"]} - NFT:${this.aluno["situacaoNftTurma"]} - ${this.aluno["etapaAtualTurma"]}º Semestre`;
                    this.aluno._formatUnidade = `${this.aluno["nomeEmpresa"]} / ${this.aluno["nomeCampus"]}`;
                    this.aluno._formatCurso = `${this.aluno["codigoEspecialidade"]} - ${this.aluno["descricaoEspecialidade"]}`
                }
            }

        },
        created() {
            if (sessionStorage.Aluno) {
                let a = JSON.parse(sessionStorage.Aluno);
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    this.gerarCamposDescritivos()
                }
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dados-item i {
        font-size: 16px !important;
        color: black !important;
        margin-right: 0.6em;
        margin-bottom: 2px;
    }

    .dados-item .data {
        display: block;
        margin-bottom: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .dados-aluno-main {
        border-bottom: 4px solid #BCC8DB !important;
    }
</style>